import React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import starIcon from '../../assets/images/star-icon.png'
import consultingImage from '../../assets/images/about/about-img10.png'
import developmentImage from '../../assets/images/about/about-img8.png'
import healthcareImage from '../../assets/images/about/about-img5.png'

const query = graphql`
  {
    strapiServicesOne {
        simpleText
        helpText
        image {
          url
        }
        services {
          id
          icon {
            url
          }
          services
        }
    }
    strapiServicesTwo {
        simpleText
        header
        helpText
        image {
          url
        }
        services {
          id
          icon {
            url
          }
          services
        }
    }
  }
`

const healthcareServices = [
    { id: 'hc-1', services: 'Blood Bank Management' },
    { id: 'hc-2', services: 'Patient Blood Management' },
    { id: 'hc-3', services: 'ISBT 128 Labeling' },
    { id: 'hc-4', services: 'Transfusion Management' },
    { id: 'hc-5', services: 'Blood Inventory Management' },
    { id: 'hc-6', services: 'Donor Management' },
    { id: 'hc-7', services: 'Healthcare System Integration' },
    { id: 'hc-8', services: 'Healthcare Reporting & Analytics' },
]

const OurServices = () => {
    const data = useStaticQuery(query)
    const {
        strapiServicesOne, strapiServicesTwo
    } = data

    return (
        <React.Fragment>
            <fieldset>
            <legend style={{width:" 80%"}}><h2>Healthcare Software Development</h2></legend>
            <p className='text-center py-4'>Secure, reliable healthcare software that improves patient care and operational efficiency.</p>
            <div className="about-area pb-100">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12">
                            <div className="about-img">
                                <img src={healthcareImage} alt='healthcare software development banner'/>
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-12">
                            <div className="about-content">
                                <div className="content">
                                    <ul className="about-list mb-0">
                                        {healthcareServices.map(service => (
                                            <li key={service.id}>
                                                <i><img src={starIcon} alt="icon" /> </i>
                                                {service.services}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <legend style={{width:" 80%"}}><h2> Consulting Services</h2></legend>
            <p className='text-center py-4'>We help you make the right technical decisions early—so your systems are efficient, scalable, and built for long-term success.</p>
            <div className="about-area pb-100">
                <div className="container-fluid">
                
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12">
                            <div className="about-img">
                                <img src={strapiServicesOne?.image?.url || consultingImage} alt='consulting services banner'/>
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-12">
                            
                            <div className="about-content">
                                <div className="content">
                                    <ul className="about-list mb-0">
                                        {strapiServicesOne?.services?.map(service => (
                                            <li key={service.id}>
                                                <i><img src={service.icon?.url || starIcon} alt="icon" /> </i>
                                                {service.services}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <legend style={{width:" 80%" ,     margin: "auto",marginBottom:'20px'}}>
            <h2>Custom Application Development</h2>
            </legend>
            <p className='text-center py-4'>Our expert application development team with 12+ years of experience builds tailored solutions that align perfectly <br/> with your business goals and also shows your story.</p>
            
            <div className="our-mission-area pb-50">
                
                <div className="container-fluid">
                
                    <div className="row align-items-center">
                    
                        <div className="col-lg-7 col-md-12">
                            
                            <div className="our-mission-content">
                                
                                <div className="content">

                                    <ul className="our-mission-list mb-0">
                                        {strapiServicesTwo?.services?.map(service => (
                                            <li key={service.id}>
                                                <i><img src={service.icon?.url || starIcon} alt="icon" /> </i>
                                                {service.services}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5 col-md-12">
                            <div className="our-mission-image">
                                <img src={strapiServicesTwo?.image?.url || developmentImage} alt='application development banner'/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </fieldset>
        </React.Fragment>
    )
}

export default OurServices;